import React from "react";

// Twin-sparkle glyph shared by the "Fit" tags and the calculating animation.
export const SparkleGlyph = ({ size = 8 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 8 8" fill="none">
    <path
      d="M3 0L3.6 2.2L5.5 2.8L3.6 3.4L3 5.5L2.4 3.4L0.5 2.8L2.4 2.2Z"
      fill="#FFD100"
    />
    <path
      d="M6 4.5L6.3 5.7L7.5 6L6.3 6.3L6 7.5L5.7 6.3L4.5 6L5.7 5.7Z"
      fill="#FFD100"
    />
  </svg>
);
